import { FechaFunctionsService } from '@/utils/functions.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pedidos-delivery',
  templateUrl: './pedidos-delivery.component.html',
  styleUrls: ['./pedidos-delivery.component.scss']
})
export class PedidosDeliveryComponent {
  deliveryForm: FormGroup;
  pedidoForm: FormGroup;
  retiros: Array<any>;
  clientes: Array<any>;
  listaProductos: Array<any> = [];
  listaMetodoPago: Array<any> = [];
  listaDirecciones: Array<any> = [];
  dateSelected: any;
  fecha_termino: any;
  rows: Array<any>;
  estados: Array<any>;
  filterForm: FormGroup;
  isLoading: boolean = false;
  isExpanded = {};
  id_cliente: number = null;
  despachoSimple: any;
  despachoDoble: any;
  latitud: number;
  longitud: number;

  constructor(private router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public generalService: GeneralService,
    public Func: FechaFunctionsService,
    public appService: AppService,
    public loadingService: LoadingService) {
  }

  async ngOnInit() {
    this.loadingService.setLoading(true)
    this.dateSelected = this.Func.Today()
    this.initializeFormRetiro();
    this.initializeForm();
    await this.getClientes();
    await this.getData();
    await this.getProductosDespachos();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((posicion) => {
        console.log(posicion); // Verifica la estructura del objeto posicion    
        this.obtenerUbicacion(posicion);
      }, this.mostrarError);
    } else {
      console.log("La geolocalización no es soportada por este navegador.");
    }
    this.loadingService.setLoading(false)
  }

  obtenerUbicacion(posicion: GeolocationPosition) {
    console.log(posicion); // Verifica la estructura del objeto posicion
    this.latitud = posicion.coords.latitude;
    this.longitud = posicion.coords.longitude;

    console.log("Latitud: " + this.latitud);
    console.log("Longitud: " + this.longitud);
  }

  mostrarError(error: GeolocationPositionError) {
    switch (error.code) {
      case error.PERMISSION_DENIED:
        console.log("El usuario denegó la solicitud de geolocalización.");
        break;
      case error.POSITION_UNAVAILABLE:
        console.log("La información de ubicación no está disponible.");
        break;
      case error.TIMEOUT:
        console.log("La solicitud de geolocalización ha caducado.");
        break;
      default:
        console.log("Se produjo un error desconocido al obtener la ubicación.");
        break;
    }
  }

  initializeForm() {
    this.deliveryForm = this.fb.group({
      fecha: [this.Func.Today(), Validators.required]
    });
  }

  initializeFormRetiro() {
    this.pedidoForm = this.fb.group({
      id_cliente: [null, Validators.required],
      nombre_cliente: [null, Validators.required],
      fecha_termino: [this.Func.addDays(new Date(), 0), Validators.required],
      observacion: ["Retiro express, se debe actualizar los productos"],
      id_estado: [2],
      productos: [this.listaProductos],
      is_pickup: [true],
      id_direccion_pickup: [null, Validators.required]
    });
  }

  async getData() {
    try {
      this.isLoading = true;
      let res = await this.generalService.getListar("pedido/delivery")
      this.rows = res.data;
      this.isLoading = false;
    } catch (error) {
      console.log(error)
      this.isLoading = false;
    }
  }


  async findRetiros(date) {
    try {
      this.dateSelected = date;
      let fecha = this.Func.DateFormated(this.dateSelected)
      this.loadingService.setLoading(true)
      this.retiros = [];
      let ruta = `pedido/delivery?fecha_termino_to=${fecha}&fecha_termino_from=${fecha}`
      let res = await this.generalService.getListar(ruta)
      this.retiros = res.data;
      this.loadingService.setLoading(false)
    } catch (error) {
      this.loadingService.setLoading(false)
    }
  }

  EditaPedido(idPedido) {
    this.loadingService.setLoading(true);
    localStorage.setItem('idPedido', idPedido);
    this.router.navigate(['/pedido']);
  }

  async onSelectItemCliente(item) {
    if (item == null) {
      this.id_cliente = null
      this.pedidoForm.get('id_cliente').setValue(null);
      this.pedidoForm.get('id_direccion_pickup').setValue(null);
      this.listaDirecciones = []
      return
    }
    this.id_cliente = item.id_cliente
    this.pedidoForm.get('id_cliente').setValue(item.id_cliente);
    await this.findCliente(item.id_cliente)
  }

  async getClientes() {
    try {
      let res = await this.generalService.getListar("cliente")
      this.clientes = res.data;
    } catch (error) {
      this.clientes = null
    }
  }

  async findCliente(idCliente) {
    try {
      let res = await this.generalService.getObtiene("cliente", idCliente)
      this.listaDirecciones = res.data.direccions;
    } catch (error) {
      this.clientes = null
    }
  }

  async saveRetiro(form) {
    try {
      this.loadingService.setLoading(true);
      this.listaProductos = [{
        id_producto: this.despachoSimple.id_producto,
        valor: this.despachoSimple.valor,
        cantidad: 1,
      }]
      let res = await this.generalService
        .postCrear("pedido", {
          "fecha_termino": this.Func.addDays(this.Func.DateFormatedBD(form.fecha_termino), 4),
          "subtotal_venta": this.despachoSimple.valor,
          "tipo_descuento": "$",
          "descuento": 0,
          "valor_despacho": this.despachoSimple.valor,
          "total_venta": this.despachoSimple.valor,
          "id_cliente": form.id_cliente,
          "observacion": form.observacion,
          "id_estado": form.id_estado,
          "is_pickup": form.is_pickup,
          "fecha_pickup": this.Func.DateFormatedBD(form.fecha_termino),
          "id_direccion_pickup": form.id_direccion_pickup,
          "is_delivery": false,
          "fecha_delivery": null,
          "id_direccion_delivery": null
        })

        this.generalService
            .postCrear("detalle_pedido", { id_pedido: res.data.id_pedido, productos: this.listaProductos })

      /* await Promise.all(this.listaProductos.map(async (e) => {
        let r = await this.generalService
          .postCrear("detalle_pedido", {
            "id_pedido": res.data.id_pedido,
            "id_producto": e.id_producto,
            "valor": e.valor,
            "cantidad": e.cantidad
          })
      })) */

      this.loadingService.setLoading(false);
      this.initializeFormRetiro();
      this.getData();
      this.findRetiros(this.dateSelected)
      this.toastr.success('Retiro creado con exito!')
    } catch (error) {
      this.toastr.error('Error al crear retiro!');
      this.loadingService.setLoading(false);
    }
  }

  async getProductosDespachos() {
    try {
      let res = await this.generalService.getListar("producto/delivery")
      this.despachoSimple = res.data.find(e => e.isDespacho === 1);
      this.despachoDoble = res.data.find(e => e.isDespacho === 2);

    } catch (error) {
    }
  }

  async updateDataDireccionPickup(event) {
    await this.findCliente(this.pedidoForm.get('id_cliente').value)
    this.pedidoForm.get('id_direccion_pickup').setValue(event)
  }

  abrirNavegacion(item): void {
    let direccion = '';
    let lat = null, lng = null

    if (item.id_estado == 2 && item.is_pickup) {
      direccion = `${item.direccion_pickup.direccion},${item.direccion_pickup.comuna_nombre},${item.direccion_pickup.provincia_nombre},${item.direccion_pickup.region_nombre}`
      lat = item.direccion_pickup.latitud
      lng = item.direccion_pickup.longitud
    }
    else if (item.id_estado == 4 && item.is_delivery) {
      direccion = `${item.direccion_delivery.direccion},${item.direccion_delivery.comuna_nombre},${item.direccion_delivery.provincia_nombre},${item.direccion_delivery.region_nombre}`
      lat = item.direccion_delivery.latitud
      lng = item.direccion_delivery.longitud
    }
    else {
      this.toastr.error('Se ha generado un error!');
      return
    }

    const url = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(direccion);

    if (navigator.userAgent.match(/iPhone|iPad|iPod|Android/i)) {
      // Dispositivo Mobile (iPhone, iPad, iPod, Android)      
      switch (this.appService.user.app_driver) {
        case "waze":
          window.location.href = `https://www.waze.com/ul?q=${encodeURIComponent(direccion)}&from=${this.latitud}%2C${this.longitud}&to=${lat}%2C${lng}&navigate=yes`;
          break;
        case "google":
          window.location.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(direccion);
          break;
        case "mapas":
          window.location.href = 'maps://maps.apple.com/?daddr=' + encodeURIComponent(direccion);
          break;
        default:
          window.open(url, '_blank');
          break;
      }
    } else {
      // Otros dispositivos (abrir en el navegador)
      //window.open(url, '_blank');
      window.open(`https://www.waze.com/ul?q=${encodeURIComponent(direccion)}&from=${this.latitud}%2C${this.longitud}&to=${lat}%2C${lng}&navigate=yes`, '_blank');
    }
  }

  openDetail(rowIndex) {
    this.rows.forEach((e, i) => {
      if (i != rowIndex) {
        this.isExpanded[i] = false
      }
    })
    this.isExpanded[rowIndex] = !this.isExpanded[rowIndex]
  }


}

